import React, { useState, useRef, useEffect } from "react";
import "./banner.css";
import "./header.css";
import cardsImage from "../../assets/BannerSection/bannerimg.svg";
import agentLabelLogo from "../../assets/BannerSection/agent-label-logo.svg";
import arrowIcon from "../../assets/BannerSection/arrow-icon.svg";
import arrowIconRed from "../../assets/BannerSection/red-arrow.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import config from "../../config";
import ImagePreloader from "../customHooks/ImagePreloader";
import StyledBorder from "../StyledBorder/StyledBorder";
import "../global/primary.css"
import "../global/grid.css";
const Banner = () => {
  const { loadedImage, isLoading } = ImagePreloader(cardsImage);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const navLinks = useRef([]);
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [ids] = useState({
    "About Us": "one",
    Solutions: "two",
    Benefits: "three",
    Features: "four",
    FAQ: "five",
  });
  const scrollToSection = (id) => {
    const headerOffset = 100; // Adjust for fixed header height
    const sectionElement = document.getElementById(id);
    const elementPosition = sectionElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const link = navLinks.current.find(
            (link) => link.dataset.target === entry.target.id
          );
          if (entry.isIntersecting) {
            link.classList.add("redirection-active");
          } else {
            link.classList.remove("redirection-active");
          }
        });
      },
      { threshold: [0.4] }
    );

    navLinks.current.forEach((link) => {
      if (!link) return;
      const sectionId = link.dataset.target;
      const sectionElement = document.getElementById(sectionId);
      observer.observe(sectionElement);
    });

    return () => {
      observer.disconnect();
    };
  }, []);
  const handleHamburgerClick = () => {
    setIsMenuActive(!isMenuActive);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(event.target)
    ) {
      setIsMenuActive(false);
    }
  };

  useEffect(() => {
    if (isMenuActive) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuActive]);

  const handleScroll = () => {
    const diff = window.innerWidth < 1024 ? 20 : 90;
    setIsHeaderActive(window.scrollY > diff);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    handleScroll(); // To set initial state on mount
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1023) {
        const mobileHamburger = document.querySelector(".mobile-hamburger");
        const mainMenu = document.querySelector(".main-navigation__menu");

        if (mobileHamburger) {
          mobileHamburger.classList.remove("is-activeHamburger");
        }
        if (mainMenu) {
          mainMenu.classList.remove("main-navigation__menu-active");
        }
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <section
      className={`banner-section ${isVisible ? "animate" : ""}`}
      ref={ref}
    >
      <div className="container">
        {/* Header */}
        <header
          className={`pricing-header header ${isHeaderActive ? "active" : ""}`}
        >
          <div className="container">
            <nav>
              <div className="elixir-logo" onClick={scrollToTop}>
                <img src={agentLabelLogo} alt="agent-label-logo" />
              </div>
              <ul className="headder-content" ref={menuRef}>
                {["About Us", "Solutions", "Benefits", "Features", "FAQ"].map(
                  (item, index) => (
                    <li
                      key={index}
                      className="elixirdata-hover-element-header"
                      tabIndex="0"
                    >
                      <a
                        href={`#${ids[item]}`}
                        data-target={ids[item]}
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToSection(ids[item]);
                        }}
                        ref={(el) => navLinks.current.push(el)}
                      >
                        <p className="platform">{item}</p>
                      </a>
                    </li>
                  )
                )}
              </ul>
            </nav>
            <div
              className={`mobile-navigation-header ${
                isHeaderActive ? "mobile-active" : ""
              }`}
            >
              <div className="mobile-logo-side">
                <a href="https://agentlabel.ai">
                  <div className="elixir-logo">
                    <img src={agentLabelLogo} alt="agent-label-logo" />
                  </div>
                </a>
              </div>
              <div
                className={`mobile-hamburger ${
                  isMenuActive ? "is-activeHamburger" : ""
                }`}
                onClick={handleHamburgerClick}
                ref={hamburgerRef}
              >
                <div className="hamburger" id="hamburger-6">
                  <span className="line"></span>
                  <span className="line"></span>
                  <span className="line"></span>
                </div>
              </div>
            </div>
            <nav
              className={`main-navigation__menu ${
                isMenuActive ? "main-navigation__menu-active" : ""
              }`}
            >
              <div className="container">
                <ul id="redirection-links" ref={menuRef}>
                  {["About Us", "Solutions", "Benefits", "Features", "FAQ"].map(
                    (item, index) => (
                      <li key={index} tabIndex="0">
                        <a
                          href={`#${ids[item]}`}
                          data-target={ids[item]}
                          onClick={(e) => {
                            e.preventDefault();
                            scrollToSection(ids[item]);
                            setIsMenuActive(false);
                          }}
                          ref={(el) => navLinks.current.push(el)}
                        >
                          <p>{item}</p>
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </nav>
          </div>
        </header>
        {/* Banner Content */}
        <div className="banner-content-wrapper">
          <div className="left-side">
            <h1>Accelerate your Dataset labeling like never before</h1>
            <p>
              The smart AI agent designed to optimize your data annotation
              process,ideal for enhancing machine learning models
            </p>
            <div className="banner-button-wrapper">
              <a href={config.bookdemo.Link}>
                <StyledBorder
                  width={"10px"}
                  color={"#FF89C1"}
                  boxColor={"#000000"}
                >
                  <button className="banner-button">
                    <p>Book Demo</p>
                    <img src={arrowIcon} alt="arrow" />
                  </button>
                </StyledBorder>
              </a>
              <a href="/watchdemo">
                <StyledBorder
                  width={"10px"}
                  color={"#FF89C1"}
                  boxColor={"#000000"}
                >
                  <button style={{backgroundColor:"white"}} className="banner-button">
                    <p style={{color:"#740037"}}>Watch Demo</p>
                    <img src={arrowIconRed} alt="arrow" />
                  </button>
                </StyledBorder>
              </a>
            </div>
          </div>
          <div className="right-side">
            {isLoading ? (
              ""
            ) : (
              <img
                src={loadedImage}
                alt="Investigation, Alerts, and Recommendation"
                loading="eager"
                decoding="sync"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
